import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { resolvePath, useQuery } from '../../routes';
import { subscription } from '../../layout/routes';

const useStyles = makeStyles(({
  container: {
    height: 56,
    borderRadius: 'border-radius/border-radius-xs',
    borderWidth: 2,
    paddingTop: 16,
    paddingRight: 40,
    paddingBottom: 16,
    paddingLeft: 40,
    backgroundColor: 'transparent',
    borderColor: '#5959EB',
    color: '#5959EB',
    fontWeight: 500,
  },
}));

const ButtonToSubscriptionManagement = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { get } = useQuery();
  const accountId = get('accountId');

  return (
    <Button
      id="goto-sub-management-page"
      variant="outlined"
      size="large"
      className={classes.container}
      sx={{
        backgroundColor: '#e7e9ef',
        color: '#233145',
        pl: 7.5,
        pr: 7.5,
        mr: 1,
      }}
      component={RouterLink}
      to={resolvePath(subscription, undefined, {
        accountId: Number(accountId),
      }, false)}
    >
      {intl.formatMessage({ id: 'payment_status.button.back_sub_management' })}
    </Button>
  );
};

export default ButtonToSubscriptionManagement;
